import Arrow from 'assets/img/smooth-arrow-left.svg';
import './SkippedDaysOverlayContent.styl';
import { ReactNode, useLayoutEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStoreContext } from 'store/app';
import { useResize } from 'src/hooks';
import Label from 'components/core/Label';

interface SkippedDaysOverlayContentProps {
    navigation: ReactNode;
}

export const SkippedDaysOverlayContent = observer(({ navigation }: SkippedDaysOverlayContentProps) => {
    const { isMob } = useStoreContext();
    const { width } = useResize();
    const [left, setLeft] = useState(isMob ? 329 : 0);

    useLayoutEffect(() => {
        if (isMob) {
            const elem = document.querySelector('.skipped-days-overlay-navigation #quests .navigation-item-icon');
            if (elem) {
                setLeft(elem.getBoundingClientRect().left - 50);
            }
        }
    }, [width]);

    return (
        <div className="skipped-days-overlay">
            <div className="skipped-days-overlay-content" style={{ left: left ? `${left}px` : undefined }}>
                <div className="skipped-days-overlay-content-title">
                    {<Label isRawHtml of="skipped.days.overlay" />}
                </div>
                <img className="skipped-days-overlay-content-arrow" src={Arrow}></img>
            </div>
            <div className="skipped-days-overlay-navigation">{navigation}</div>
        </div>
    );
});
